import React, { useState } from 'react';
import {
  AppBar,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  SwipeableDrawer,
  TextField,
  IconButton,
  Typography,
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import MessageIcon from '@mui/icons-material/Message';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CloseIcon from '@mui/icons-material/Close';

const Navigation = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const toggleDrawer = (isOpen) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setOpen(isOpen);
  };
  return (
    <Box>
      <AppBar
        position="fixed"
        sx={{
          top: 'auto',
          bottom: 0,
        }}
      >
        <BottomNavigation showLabels>
          <BottomNavigationAction label="phone" icon={<PhoneIcon />} />
          <BottomNavigationAction
            label="message"
            icon={<MessageIcon />}
            onClick={handleOpen}
          />
          <BottomNavigationAction label="camera" icon={<CameraAltIcon />} />
        </BottomNavigation>
      </AppBar>
      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        PaperProps={{
          sx: { borderTopLeftRadius: 16, borderTopRightRadius: 16 },
        }}
      >
        <Box
          sx={{
            padding: 2,
            height: '50vh', // Adjust height as needed
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">Edit Description</Typography>
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <TextField
            autoFocus
            margin="dense"
            placeholder="Enter description here..."
            type="text"
            fullWidth
            multiline
            rows={6} // Adjust the number of rows as needed
            variant="outlined"
          />
        </Box>
      </SwipeableDrawer>
    </Box>
  );
};

export default Navigation;
